import { IUsers } from 'CommonTypes/Tasks/QuickAddTaskForm/IResponse';

export default (assignees: IUsers[], defaultAssigneeId: number, configAssignee?: IUsers) => {
    if (configAssignee) return configAssignee;
    const defaultAssignee = assignees.find(assignee => assignee.id === +defaultAssigneeId);

    return defaultAssignee ?? null;
};
